import React from 'react';
import PropTypes from 'prop-types';
import { FDImage, FDVideo } from '@facet-wealth/design';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { dataAttrs } from 'Helpers/Testing';

export const MediaRel = ({
  relationship, width, height, flex,
}) => {
  const theme = useTheme();

  // The relationship could have been missing, in which case we shouldn't render an image
  if (!relationship) {
    return null;
  }

  const mediaType = relationship.meta('mediaType');

  const aspectRatio = relationship.meta('aspectRatio');
  const altText = relationship.meta('altText') ?? ''; // If alt text is missing, FD will blow up - use an empty string as in that case
  const url = relationship.link('related').url();

  switch (mediaType) {
    case 'image':
      return (
        <FDImage
          alt={altText}
          src={url}
          width={width}
          height={height}
          flex={flex}
          aspectRatio={aspectRatio}
        />
      );
    case 'video':
      return (
        <div
          style={{
            display: 'flex',
            borderRadius: theme.spacing(1),
            width: '100%',
            boxShadow: theme.shadows[23],
          }}
          {...dataAttrs('media-rel-video-container')}
        >
          <FDVideo
            alt={altText}
            src={url}
            width={width}
            height={height}
            aspectRatio={aspectRatio}
            flex={flex}
            captionsSrc={relationship.meta('caption') ?? ''}
          />
        </div>
      );
    default:
      return null;
  }
};

MediaRel.defaultProps = {
  relationship: undefined,
  width: '100%',
  height: undefined,
};

MediaRel.propTypes = {
  relationship: PropTypes.object,
  width: PropTypes.string,
  height: PropTypes.string,
};
